import React from 'react';
import PropTypes from 'prop-types';
import styles from './BenefitItem.pcss';
import HorizontalRule from '../../common/HorizontalRule';

const BenefitItem = props => (
    <div className={styles.benefitItem}>
        <div>
            <h3>{props.title}</h3>
            <HorizontalRule />
            <div dangerouslySetInnerHTML={{__html: props.description}} />
        </div>
    </div>
);

BenefitItem.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

export default BenefitItem;
